import { SelectChangeEvent } from "@mui/material";
import { useAuth } from "react-oidc-context";
import { useLoaderData, useNavigate } from "react-router";
import { redirect, useLocation, useParams } from 'react-router-dom';
import { capitalizeString } from "../../utils";
import { config } from "../../utils/config";
import { doFetch } from "../../utils/doFetch";
import { WorkInfo } from "./WorkInfo";
import { IWorkInformation } from "./WorkInfoData";
import { COASTWISE_CATEGORIES, Category, Region, SQUAMISH_CATEGORIES, VANCOUVER_CATEGORIES } from "./WorkInfoModels";

const drMode = config.drMode === 'true' || config.drMode === true;

export const workInfoRouteLoader = async ({ request, params }: { request: any, params: any }) => {
  if (params.category) {
    // handles region/category change
    return doFetch(`work-info/${params.region}/${params.category}`, { signal: request.signal }, true, false);
  } else {
    // handles default board
    return redirect("all");
  }
}

export const WorkInfoRoute = () => {
  const data = useLoaderData() as IWorkInformation;
  const { category = 'all', region = 'vancouver' } = useParams();
  const navigate = useNavigate();
  const auth = useAuth();
  const location = useLocation();
  const selectedCategory = category === 'firstaid' ? Category.firstaid : capitalizeString(category) as Category;

  const handleChangeRegion = (event: SelectChangeEvent<Region>) => {
    const newRegion = Object.keys(Region).find(key =>
      Region[key as keyof typeof Region] === event.target.value);

    const notLocalCategories = newRegion === Region.squamish ? SQUAMISH_CATEGORIES : COASTWISE_CATEGORIES;
    const categories = newRegion === Region.vancouver ? VANCOUVER_CATEGORIES : notLocalCategories;
    const categoryValue = category === 'firstaid' ? Category.firstaid : capitalizeString(category);
    const newCategory = categories.includes(categoryValue as Category) ? category : Category.all;
    navigate(`/work-info/${newRegion?.toLowerCase()}/${newCategory.toLowerCase()}`);
  };

  const handleChangeCategory = (event: SelectChangeEvent<Category>) => {
    const newCaterogy = Object.keys(Category).find(key =>
      Category[key as keyof typeof Category] === event.target.value);

    navigate(`/work-info/${region.toLowerCase()}/${newCaterogy}`);
  };

  const handleViewBrochure = () => window.open('/assets/documents/dispatch_brochure.pdf');

  const handleAvailabilityButtonClick = async () => {
    const pathname = drMode ? '/dr-plugin-availability' : '/doa';
    if (auth.isAuthenticated) {
      navigate(pathname);
    } else {
      try {
        /// The state helps our WebClient know to redirect the user to /doa after initiating sign in from this page
        /// The timestamp helps our IdentityServer distinguish stale sign-in state (ex. Bookmarked sign-in page)
        await auth.signinRedirect({
          state: { ...location, pathname },
          extraQueryParams: {
            timestamp: Date.now() + (10 * 60 * 1000)
          }
        });
      } catch (e: any) {
        alert("Error redirecting to sign in page. Please try again");
      }
    }
  }

  return (
    <WorkInfo
      drMode={drMode}
      data={data}
      hasAll={category === 'all'}
      selectedCategory={selectedCategory}
      selectedRegion={capitalizeString(region) as Region}
      handleChangeCategory={handleChangeCategory}
      handleChangeRegion={handleChangeRegion}
      handleViewBrochure={handleViewBrochure}
      handleAvailabilityButtonClick={handleAvailabilityButtonClick}
    />
  )
}